import { useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";

// Handles returning from Stripe Checkout: polls payment status and reports a
// confirmed booking via onConfirmed. Runs once on mount.
export function usePaymentReturn(onConfirmed) {
  const [verifying, setVerifying] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const sessionId = params.get("session_id");
    if (params.get("canceled")) {
      toast.error("Payment canceled. Your reservation is not confirmed yet.");
      window.history.replaceState({}, "", window.location.pathname);
      return;
    }
    if (!sessionId) return;

    setVerifying(true);
    let attempts = 0;
    const poll = async () => {
      if (attempts >= 8) {
        setVerifying(false);
        toast.error("We couldn't confirm your payment yet. If you were charged, please call 978-221-1451.");
        return;
      }
      try {
        const res = await api.get(`/payments/status/${sessionId}`);
        if (res.data.payment_status === "paid") {
          setVerifying(false);
          onConfirmed(res.data.booking);
          window.history.replaceState({}, "", window.location.pathname);
          window.scrollTo(0, 0);
          return;
        }
        if (res.data.status === "expired") {
          setVerifying(false);
          toast.error("Payment session expired. Please try again.");
          return;
        }
        attempts += 1;
        setTimeout(poll, 2000);
      } catch {
        setVerifying(false);
        toast.error("Error confirming payment. Please try again.");
      }
    };
    poll();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return verifying;
}
